import yup from "../../../../../utils/yup-extended";

export const hasOptions = ["radio-button", "checkbox", "dropdown"];

export const offeringCheckoutFormValidationSchema = yup.object().shape({
  bookingQuestions: yup.array().of(
    yup.object().shape({
      question: yup.string().trim().required("Question is required"),
      answerType: yup
        .string()
        .oneOf(
          ["short-text", "long-text", "radio-button", "checkbox", "dropdown", "link"],
          "Select an answer type"
        ),
      required: yup.bool().default(false),
      options: yup
        .array()
        .of(
          yup.object().shape({
            optionLabel: yup.string().required("Option is required"),
          })
        )

        .when("answerType", {
          is: (
            answerType:
              | "short-text"
              | "long-text"
              | "radio-button"
              | "checkbox"
              | "dropdown"
              | "link"
          ) => hasOptions.includes(answerType),
          then: (schema) => schema.required("Option is required").min(1, "Add an option"),
          otherwise: (schema) => schema,
        }),
    })
  ),
});
